export const TINYMCE_FONT_STYLE = `@font-face {
            font-family: "Conv_Gotham-Book";
            src: url("../../../../assets/fonts/Gotham-Book.eot");
            src: local("☺"),
            url("../../../../assets/fonts/Gotham-Book.woff") format("woff"),
            url("../../../../assets/fonts/Gotham-Book.ttf") format("truetype"),
            url("../../../../assets/fonts/Gotham-Book.svg") format("svg");
            font-weight: normal;
            font-style: normal;
          }
          @font-face {
            font-family: "Conv_Gotham-Book";
            src: url("../../../../assets/fonts/Gotham-BookItalic.woff") format("woff");
            font-weight: normal;
            font-style: italic;
          }
          @font-face {
            font-family: "Conv_Gotham-Bold";
            src: url("../../../../assets/fonts/Gotham-Bold.eot");
            src: local("☺"),
            url("../../../../assets/fonts/Gotham-Bold.woff") format("woff"),
            url("../../../../assets/fonts/Gotham-Bold.ttf") format("truetype"),
            url("../../../../assets/fonts/Gotham-Bold.svg") format("svg");
            font-weight: bold;
            font-style: normal;
          }`;

export const TINYMCE_BASE_BODY_STYLE = `body {
            font-size: 10pt !important;
            font-family: "Conv_Gotham-Book", "Helvetica Neue", sans-serif !important;
          }
          strong, b { font-family: "Conv_Gotham-Bold", "Helvetica Neue", sans-serif !important; font-weight: bold !important; }`;
